<script setup lang="ts">
import type { EquipmentType } from '@optionway/models';

defineProps<{
  type: EquipmentType;
}>();
</script>

<template>
  <SvgoResultsSegmentBus
    v-if="type === 'BUS'"
    class="h-3.5 w-3.5 shrink-0 text-dark-blue-700"
    filled
    :font-controlled="false"
  />
  <SvgoResultsSegmentTrain
    v-else-if="type === 'TRAIN'"
    class="h-3.5 w-3.5 shrink-0 text-dark-blue-700"
    filled
    :font-controlled="false"
  />
</template>
